module.exports = __webpack_public_path__ + "img/full4-min.c43bd997.png";